export const accountSettingsSectionIds = ["general", "security"] as const;
export const workspaceSettingsSectionIds = ["editor", "cache", "integrations"] as const;

export type AccountSettingsSection = (typeof accountSettingsSectionIds)[number];
export type WorkspaceSettingsSection = (typeof workspaceSettingsSectionIds)[number];
export type SettingsSection = AccountSettingsSection | WorkspaceSettingsSection;
export type SettingsScope = "account" | "workspace";

export function sectionIdsForScope(scope: SettingsScope): readonly SettingsSection[] {
  return scope === "account" ? accountSettingsSectionIds : workspaceSettingsSectionIds;
}

export function defaultSectionForScope(scope: SettingsScope): SettingsSection {
  return scope === "account" ? "general" : "editor";
}
